import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuthStore } from '../store/authStore';
import { authApi } from '../services/api/authApi';

const AuthCallbackPage: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const setAuth = useAuthStore(state => state.setAuth);

    useEffect(() => {
        const handleCallback = async () => {
            const params = new URLSearchParams(location.search);
            const token = params.get('token');

            if (token) {
                try {
                    // Temporarily store token so getMe can use it via interceptor
                    localStorage.setItem('authToken', token);

                    // Fetch user info
                    const response = await authApi.getMe();

                    if (response.success) {
                        setAuth(response.data, token);
                        navigate('/dashboard');
                    } else {
                        navigate('/auth/login?error=profile_fetch_failed');
                    }
                } catch (error) {
                    console.error('SSO Callback Error:', error);
                    navigate('/auth/login?error=callback_processing_failed');
                }
            } else {
                const error = params.get('error');
                navigate(`/auth/login?error=${error || 'no_token'}`);
            }
        };

        handleCallback();
    }, [location, navigate, setAuth]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                gap: 2
            }}
        >
            <CircularProgress />
            <Typography variant="h6">Completing sign in...</Typography>
        </Box>
    );
};

export default AuthCallbackPage;
